import { useEffect, useState } from 'react';
import Select from 'react-select';
import { GetEntryData } from '../../store/vendorAtom';
import underscore from 'underscore';

function VendorBillingCityComponent(props) {
  const entryMasterData = GetEntryData();
  const [customOption, setCustomOption] = useState([]);

  useEffect(() => {
    var masterDataGroup = underscore?.groupBy(entryMasterData, 'Master_Type');
    let countryList = masterDataGroup?.[3];

    // Filter out undefined values by using filter instead of map
    const tempData =
      countryList
        ?.filter(element => element.Parent_Code1 === props?.stateCode)
        .map(element => ({
          ...element,
          label: `${element?.Name}`,
          value: element?.Name, // Add value prop for react-select
        })) || [];

    setCustomOption(tempData);
  }, [entryMasterData, props?.stateCode]);

  const customStyles = {
    control: base => ({
      ...base,
      height: 42,
      backgroundColor: '#F1F1F1',
    }),
    indicatorSeparator: styles => ({ ...styles, display: 'none' }),
    valueContainer: styles => ({ ...styles, backgroundColor: '', height: 20, paddingBottom: '45px', marginLeft: '13px' }),
    option: styles => ({ ...styles, backgroundColor: '#F1F1F1', color: 'black' }),
    menuPortal: styles => ({ ...styles, zIndex: 9999 }),
  };

  const handleChange = value => {
    props.onBillingCitySelect(value);
  };

  return (
    <>
      <Select styles={customStyles} onChange={handleChange} defaultValue={props?.defaultVal} options={customOption} />
    </>
  );
}

export default VendorBillingCityComponent;
